import React from 'react';
import './progressBar.css'; // Import your custom CSS

const ProgressBar = ({ percentage }) => {
    console.log(percentage)
  return (
    <div className="progress-container-div-vdo">
    <div className="progress-bar-vdo">
        <div className="progress-fill-vdo" style={{ width: `${percentage}%` }}></div>
    </div>
    <span className="percentage-text-vdo">{percentage}%</span>
</div>

  );
};

export default ProgressBar;
